import React, { useEffect } from "react";
import About from "../Components/About/About";
import Events from "../Components/Events/Events";
import Gallery from "../Components/Gallery/Gallery";
import Landing from "../Components/Landing/Landing";
import Map from "../Components/Map/Map";
import Statistics from "../Components/Statistics/Statistics";
import WhyRight from "../Components/WhyRight/WhyRight";
import TrackVisibility from "react-on-screen";
import Teachers from "../Components/Teachers/Teachers";

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div>
      <Landing />
      <WhyRight />
      <About />
      <Events />
      <TrackVisibility partialVisibility={true}>
        <Statistics />
      </TrackVisibility>
      <Teachers />
      <Gallery />
      <Map />
    </div>
  );
}
